import { createContext, useState } from 'react';

const StepperContext = createContext();

export function StepperProvider ({ children }) {
    const [currentStep, setCurrentStep] = useState(0);
    const nextStep = (increment = 1) => {
        setCurrentStep((prev) => {
            const maxStep = 2;
            return Math.min(prev + increment, maxStep);
        });
    };
    const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 0));
    
    return (
        <StepperContext.Provider value={{ currentStep, nextStep, prevStep }}>
            {children}
        </StepperContext.Provider>
    );
};
  
  export default StepperContext;

